import { NavigationGroup, SEO } from './page'
import { CTA } from './cta'
import { FAQGroup } from './faq'
import { PostLink } from './landingPage'
import { RichText } from './post'
import {
  BGVariants,
  HeroTextSection,
  HeroTextTwoColumnSection,
  HideOn,
  HorizontalSplit2ColumnSection,
  TextColumn,
} from './heroTextSection'
import { AssetFluid } from './asset'
import { PackagesSection, PackageSection } from './packages'
import { Carousel } from './carousel'
import { ProductPackageSection, ProductPackagesSection } from './productPageV2'
import { ReviewSectionNonTrustPilot } from './review'
import { CssEntry } from './contentfulAttributes'

export interface LandingPageV2 {
  name: string
  title: string
  slug: string
  rows: Row[]
  seo: SEO | null
  contentful_id: string
  __typename: 'ContentfulLandingPageV2'
  createdAt: string
  updatedAt: string
  fields?: {
    parsedSlug: string
  }
}

export interface Banner {
  contentful_id: string
  name: string
  text: RichText
  components: (TextColumn | CustomComponent)[]
  images: AssetFluid[]
  variant: BannerVariants
  backgroundColor: BGVariants
  textColor: TextColors
  codeClasses: string[] | null
  __typename: 'ContentfulBanner'
  css: CssEntry[] | null
  hideOn: HideOn
}
export enum TextColors {
  Dark = 'Dark',
}
export enum BannerVariants {
  FullWidth = 'Fullwidth',
  FullWidthNarrow = 'FullWidthNarrow',
}

export interface CustomComponent {
  contentful_id: string
  name: CustomComponentTypes
  __typename: 'ContentfulCustomComponent'
  hideOn: HideOn
}

export interface SpacerComponent {
  contentful_id: string
  __typename: 'ContentfulSpacer'
  name: string
  color: BGVariants
  size: 'small' | 'medium' | 'large'
  hideOn: HideOn
}

export enum CustomComponentTypes {
  ContactForm = 'Contact Form',
  ContactFormInSection = 'Contact Form in Section',
  DoNotSellForm = 'Do Not Sell Form',
  InPostServices = 'In-Post Services',
  PackageExecutive = 'Package Card (Executive)',
  PackageExecutiveExpanded = 'Package Card (Executive Expanded)',
  PackageFastTrack = 'Package Card (Fast Track)',
  PackageLaunch = 'Package Card (Launch)',
  PackagePremium = 'Package Card (Premium)',
  PackageReview = 'Package Card (Review)',
  PhoneNumber = 'Phone Number',
  PricingPackages = 'Pricing Packages',
  PricingPackagesWithReview = 'Pricing Packages with Free Review',
  PurchaseFooter = 'Price Footer',
  TrustPilotColumn = 'TrustPilot Column',
  TrustPilotRatingWidget = 'TrustPilot Rating Widget',
  AffirmPrice = 'Affirm Price',
  Press = 'Press',
  Match = 'Match',
  PartnershipsForm = 'Partnerships Form',
  NewsletterForm = 'Newsletter Form',
  NotFindingWhatYouWantTry = 'Not finding what you want try',
  LearnMore = 'Learn more',
}

export interface Profile {
  contentful_id: string
  __typename: 'ContentfulProfile'
  name: string
  title: string | null
  profilePicture: AssetFluid | null
}

export interface Testimonial {
  contentful_id: string
  __typename: 'ContentfulTestimonial'
  testimonialName: string
  rating: number | null
  quote: RichText | null
  profile: Profile | null
}

export interface ReviewSection {
  contentful_id: string
  name: string
  __typename: 'ContentfulReviewSection'
  subtitle: string
  body: RichText
  backgroundColor: BGVariants
  reviewBackgroundColor: BGVariants
  customReviewComponent: ReviewComponentVariants
  tag: ReviewTagVariants
  externalBrand: string
  codeClasses: string[] | null
  css: CssEntry[] | null
  hideOn: HideOn
}

export enum ReviewTagVariants {
  linkedIn = 'LinkedIn',
  shownOnWebsite = 'shown-on-website',
}

export enum ReviewComponentVariants {
  SimpleCarousel = 'Simple Carousel',
  MasonryCarousel = 'Masonry Carousel',
  FullWidthCarousel = 'Full Width Carousel',
  ProgressBarCarousel = 'Progress Bar Carousel',
}

export interface AuthorSocialMedia {
  contentful_id: string
  __typename: 'ContentfulAuthorSocialMedia'
  authorName: string
  linkedIn?: string
  instagram?: string
  facebook?: string
  twitter?: string
}

export interface AuthorPosts {
  contentful_id: string
  __typename: 'ContentfulAuthorPosts'
  name: string
  sideCta: CTA | null
}

export enum RBBVariants {
  HearFromCustomers = 'Hear From Customers',
  ResumeExamples = 'Resume Examples',
  HeroCentered = 'Hero Centered',
  HomeResumeExamples = 'Home Resume Examples',
  Custom = 'Custom'
}

export interface RoundBackgroundBlock {
  contentful_id: string
  __typename: 'ContentfulRoundBackgroundBlock'
  variant: RBBVariants
  codeClasses: string[] | null
  content: RichText
  bottom: RichText
  images: AssetFluid[]
}

export type DynamicProductsSection = {
  __typename: 'ContentfulDynamicProductsSection'
  pageKind: 'Job Search' | 'Resume Writing'
}

export type Row =
  | CTA
  | HeroTextSection
  | HeroTextTwoColumnSection
  | FAQGroup
  | NavigationGroup<PostLink>
  | Banner
  | CustomComponent
  | PackagesSection
  | PackageSection
  | ReviewSection
  | Carousel
  | SpacerComponent
  | HorizontalSplit2ColumnSection
  | ProductPackagesSection
  | ProductPackageSection
  | ReviewSectionNonTrustPilot
  | AuthorSocialMedia
  | AuthorPosts
  | RoundBackgroundBlock
  | DynamicProductsSection
